import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { TaskFileService } from '../../../../services/task-file.service';

@Component({
	selector: 'app-components-specialist-actioncomponents-files',
	templateUrl: './files.component.html'
})
export class FilesComponent implements OnInit {
    @Input() taskId: number;
    @Output() fileCount = new EventEmitter<number>();

    loading = true;
    files: Boo.Objects.TaskFile[];

    constructor(private taskFileService: TaskFileService) {}

    ngOnInit(): void {
      this.taskFileService.getByTaskId(this.taskId)
      .pipe(
        finalize(() => this.loading = false)
      )
      .subscribe({
        next: (files) => {
          this.files = files;
          this.fileCount.emit(files.length);
        }
      });
    }
}
